import { Button, Card, CardBody } from '@heroui/react';
import React from 'react';
import { FiHome, FiAlertCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen p-6 bg-default-50">
      <Card className="max-w-lg w-full">
        <CardBody className="p-12 text-center">
          <div className="w-20 h-20 rounded-full bg-danger-100 flex items-center justify-center mx-auto mb-6 text-danger-600">
            <FiAlertCircle size={40} />
          </div>
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            Page Not Found
          </h2>
          <p className="text-lg text-default-500 mb-8 leading-relaxed">
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </p>
          <Button
            as={Link}
            to="/dashboard"
            color="primary"
            startContent={<FiHome size={16} />}
          >
            Back to Dashboard
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};
